module.exports = __webpack_public_path__ + "static/media/trckova.68af86bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/trckova.jpg
// module id = 559
// module chunks = 0